const getBytes = str => {
	// feat : validation use
	if (str === null || str === undefined) return false;
	return str
		.split('')
		.map(s => s.charCodeAt(0))
		.reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
};

export default getBytes;
